import useGetGeneralSettings from "@src/providers/useGetGeneralSettings";

export const isVisibleCreateServiceButton = () => {
    const generalSettings = useGetGeneralSettings();
    const serviceCreatorSettings = generalSettings.find(setting => setting.name == 'ServiceCreator');

    return serviceCreatorSettings?.config?.show_create_service_option
}